import { C } from '../../lib/tokens.js';
import { t } from '../../lib/i18n.jsx';
import { Modal } from '../ui/Modal.jsx';
import { Button } from '../ui/Button.jsx';

// "Still there?" countdown before the idle logout - see useAutoLogout. No onClose on
// purpose: a backdrop click or Escape must not count as "stay signed in", only the button.
export function IdleWarningModal({ secondsLeft, onStay, onLogoutNow }) {
  return (
    <Modal width={380}>
      <div style={{ fontSize: 15, fontWeight: 500, color: C.deepsea }}>{t('idle.title')}</div>
      <div style={{ fontSize: 13, color: C.iron }}>
        {t('idle.body').replace('{seconds}', secondsLeft)}
      </div>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <Button kind="outline" onClick={onLogoutNow}>{t('idle.logout_now')}</Button>
        <Button kind="primary" onClick={onStay}>{t('idle.stay')}</Button>
      </div>
    </Modal>
  );
}

// Notice before MaxTokenValidity ends the session - see useSessionExpiry. Nothing to
// extend, so it only informs.
export function SessionEndingModal({ expiresAt, locale, onClose }) {
  const time = new Date(expiresAt).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  return (
    <Modal onClose={onClose} width={380}>
      <div style={{ fontSize: 15, fontWeight: 500, color: C.deepsea }}>{t('session_end.title')}</div>
      <div style={{ fontSize: 13, color: C.iron }}>
        {t('session_end.body').replace('{time}', time)}
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button kind="primary" onClick={onClose}>{t('session_end.ok')}</Button>
      </div>
    </Modal>
  );
}
